import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { show } from 'store/reducers/modals'

import Link from 'components/Link'
import classes from './Footer.scss'

export const Footer = (props) => <footer className={classes.footer}>
  <p>
    &copy; TwoXSea
    &nbsp;<Link title='Contact Us' onClick={(e) => {
      e.preventDefault()
      return props.dispatch(show('feedback'))
    }}>Have a question?</Link>
  </p>
</footer>

Footer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

Footer.defaultProps = {}

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js